<template>
  <div 
  class="mt-2" 
  style="max-width: 500px;"
  >
    <v-toolbar 
    class="elevation-1 white--text" 
    color="primary" 
    height="50px"
    >
      <v-toolbar-title>
        Course Types
      </v-toolbar-title>
      <v-divider 
      class="mx-2" 
      inset 
      vertical 
      />
      <v-spacer />
      <AddCourseTypeDialog />
      <EditCourseTypeDialog />
    </v-toolbar>
    <v-data-table 
    :headers="headers" 
    :items="courseTypeList" 
    class="elevation-1" 
    v-if="courseTypeList !== undefined"
    >
      <template 
      slot="item" 
      slot-scope="props"
      >
        <tr>
          <td class="text-xs-left">
            {{ props.item.name }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon 
            @click="editItem(props.item)" 
            class="mr-2" 
            small 
            style="display: inline-flex;"
            >
              edit
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { FETCH_COURSE_TYPE_LIST } from "../../../store/course_type/actions.js";
import { LOAD_COURSE_TYPE_TO_EDIT, TOGGLE_EDIT_COURSE_TYPE_DIALOG } from "../../../store/course_type/mutations.js";
import EditTableFunctions from './../../../components/editTableFunctions';
import AddCourseTypeDialog from "./AddCourseTypeDialog";
import EditCourseTypeDialog from "./EditCourseTypeDialog";

export default {
  components: {
    AddCourseTypeDialog,
    EditCourseTypeDialog
  },
  mixins: [
    EditTableFunctions,
  ],
  data() {
    return {
      dialog: false,
      breadcrumbPath: [{ text: process.env.VUE_APP_SYSTEM_NAME, to: "/" }, { text: 'Manage Course Types', disabled: true, }],
      loading: true,
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        { text: 'Actions', align: 'center', value: 'name', sortable: false }
      ],
      rowsPerPageItems: [10, 20, 50, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }],
      pagination: {
        rowsPerPage: 10
      },
      editedId: -1,
      idName: 'id',
    };
  },

  computed: {
    ...mapGetters(
      [
        "courseTypeList",
      ]
    ),
    newCourseTypeName: {
      get() {
        return this.$store.state.courseType.addCourseType.name;
      },
      set(value) {
        this.updateValue('name', value);
      },
    },
  },

  mounted() {
    this.fetchAllTableItems();
    if (
      this.$route.params !== undefined
      && this.$route.params.id !== undefined) {
      this.id = this.$route.params.id;

    }
  },

  methods: {
    ...mapActions({
      fetchTableList: FETCH_COURSE_TYPE_LIST,
    }),

    ...mapMutations({
      toggleEditDialog: TOGGLE_EDIT_COURSE_TYPE_DIALOG,
      loadTableItemToEdit: LOAD_COURSE_TYPE_TO_EDIT,
    })
  },
}
</script>